/* src/app/pages/usage-reports/usage-reports.component.scss */
.full-width {
  width: 100%;
}
.matwidth {
  width: 300px;
}
table {
  width: 100%;
}
/*# sourceMappingURL=usage-reports.component.css.map */
